import { Finish } from './Finish';
import { Orientation } from './Orientation';

export interface Gradient {
  getStyle(finish: Finish, orientation: Orientation): {};
}

export class NoneGradient implements Gradient {
  getStyle(finish: Finish, orientation: Orientation): {} {
    return {
      display: 'none'
    };
  }
}

function createRGBA(rgb: number[], alpha: number) {
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}

export class ClassicGradient implements Gradient {
  constructor(private color: number[] = [255, 255, 255]) {}

  getStyle(finish: Finish, orientation: Orientation): {} {
    switch (finish.id) {
      case 'classic':
      case 'simple':
        return this.getStyleDependingOnOrientation(orientation);

      default:
        return {
          display: 'none'
        };
    }
  }

  private getStyleDependingOnOrientation(orientation: Orientation): {} {
    switch (orientation) {
      case 'panoramic':
        return this.getPanoramicStyle();

      default:
        return this.getDefaultStyle();
    }
  }

  private getDefaultStyle(): {} {
    return {
      position: 'absolute',
      top: '80%',
      width: '100%',
      bottom: 0,
      left: 0,
      background:
        `linear-gradient(to bottom, ${createRGBA(this.color, 0)} 0%, ` +
        `${createRGBA(this.color, 0.75)} 35%, ${createRGBA(this.color, 1)} 62%, ${createRGBA(this.color, 1)} 100%)`
    };
  }

  private getPanoramicStyle(): {} {
    return {
      position: 'absolute',
      bottom: 0,
      left: '33%',
      top: '80%',
      width: '33%',
      'border-top-left-radius': '75%',
      'border-top-right-radius': '75%',
      background:
        `radial-gradient(at bottom, ${createRGBA(this.color, 1)} 0%, ${createRGBA(this.color, 0.975)} 20%,` +
        `${createRGBA(this.color, 0.95)} 40%, ${createRGBA(this.color, 0.81)} 60%, ${createRGBA(
          this.color,
          0.48
        )} 80%,` +
        `${createRGBA(this.color, 0)} 100%)`
    };
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/models/Gradient.ts